// -- import * as _ from "lodash-es"
import Vue from "vue"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"
import * as common_controller from "../commonController"

const content_type = "sPlant_OrderForecast_Line"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [

    {
      key: "ForecastSalesId",
      label: "预测订单编码",
      sortable: true,
      thStyle: { width: "120px" },
      width: "150px"
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      width: "80px"
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      width: "8rem",
      sortable: true,
      thStyle: { width: "8rem" },
      type: "short"
    },
    {
      key: "CustAccountId",
      label: "客户账户",
      sortable: true,
      width: "80px"
    },
    {
      key: "CustAccountName",
      label: "客户名称",
      sortable: true,
      thStyle: { width: "8rem" },
      type: "short"
    },
    {
      key: "seq",
      label: "行号",
      sortable: true,
      width: "40px"
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "SalesQty",
      label: "数量",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "valid_remain",
      label: "剩余派单数量",
      sortable: true,
      thStyle: { width: "120px" },
      type: "number",
      _precise: 6
    },

    {
      key: "SalesUnitId",
      label: "单位",
      sortable: true
    },
    {
      key: "Currency",
      label: "币种",
      sortable: true
    },
    {
      key: "SEI_DimensionFG",
      label: "FG维度",
      sortable: true
    },
    {
      key: "is_invent_ready",
      label: "备料",
      sortable: true,
      type: "boolean"
    },
    {
      key: "StartDate",
      label: "装运日期",
      sortable: true,
      type: "date"
    },
    {
      key: "SEI_CP_ReplenishmentCommit",
      label: "补货计划",
      sortable: true
    },
    {
      key: "WeekName",
      label: "周的名称",
      sortable: true
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true,
      thStyle: { width: "120px" },
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "is_cancel",
      label: "取消",
      sortable: true,
      type: "boolean"
    },
    {
      key: "SFDApprovedState",
      label: "派发审批状态",
      sortable: true,
      thStyle: { width: "120px" },
      type: "state",
      context: ["待审批", "已审批"]
    }
  ],
  dicpatch_fields: [
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "11rem"
      }
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "ModelId",
      label: "预测模型",
      editable: true
    },
    {
      key: "SEI_ForecastSalesType",
      label: "预测类型",
      editable: true,
      type: "textarea"
    },
    {
      key: "qty",
      label: "数量",
      editable: true,
      type: "number"
    },
    // {
    //   key: "price",
    //   label: "成本",
    //   editable: true,
    //   type: "number"
    // },
    {
      key: "delivery_date",
      label: "装运日期",
      editable: true,
      type: "date"
    },
    {
      key: "Capacity",
      label: "产能(天)",
      editable: true,
      type: "number"
    },
    {
      key: "RetailVariantId",
      label: "变形编号",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId"
    },
    {
      key: "SEI_CP_ReplenishmentCommit",
      label: "补货计划"
    },
    {
      key: "WeekName",
      label: "周的名称"
    },
    {
      key: "TotalScore",
      label: "评价",
      sortable: true,
      type: "rate",
      disabled: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true
    },
    {
      key: "create_at",
      label: "创建时间",
      type: "datetime"
    },
    {
      key: "update_by",
      label: "修改人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.update_by_username
      }
    },
    {
      key: "update_at",
      label: "修改时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "fcGetSFDispatchApprover",
      label: "待审批人",
      sortable: true,
      formatter: (value, key, item) => {
        if (
          !_.isNull(item.fcGetSFDispatchApprover) &&
          item.fcGetSFDispatchApprover
        ) {
          return item.fcGetSFDispatchApprover.split(",")[0]
        } else {
          return ""
        }
      }
    },

    {
      key: "fcCheckSFDApproved",
      label: "审批",
      sortable: true,
      type: "state",
      state_control: "fcCheckSFDApproved",
      other_type_key: "is_email_send",
      context: ["待审批", "已审批", "审批中"]
    },
    {
      key: "SFDApprovedState",
      label: "审批状态名称",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId",
      formatter: (value, key, item) => {
        if (item.fcCheckSFDApproved) {
          item.SFDApprovedState = "已审批"
          return "已审批"
        } else if (item.is_email_send) {
          item.SFDApprovedState = "审批中"
          return "审批中"
        } else {
          item.SFDApprovedState = "待审批"
          return "待审批"
        }
      }
    }
  ]
}

const dataForm = {
  id: "",
  saleOrder_num: "",
  cust_name: "",
  product_name: "",
  supplier_num: "",
  price: "",
  qty: "",
  delivery_date: new Date()
}

///前端验证
const rules = {}

const descriptor = {}
const methods = {
  ///get 查询预测派单明细
  async getDispatchData(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_OrderForecast_Dispatch",
      {},
      {}
    )
    let _fields = _.map(fields.dicpatch_fields, "key")
    _fields.push("id")
    _fields.push("OrderForecast_Line_id")
    _fields.push("approved_at")
    _fields.push("AXSalesId")
    _fields.push("AXInventTransId")
    _fields.push("AXPurchId")
    _fields.push("AXPurchInventTransId")
    _fields.push("AXId")
    _fields.push("fcCheckSFDApproved(t.id)")
    _fields.push("is_email_send")

    let result = await item_biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///get 派单详情
  async getDispatchItems(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "get_sf_dispatch",
      {},
      {}
    )
    let _fields = _.map(fields.dicpatch_fields, "key")
    _fields.push("id")
    // _fields.push("RetailVariantId");
    _fields.push("OrderForecast_Line_id")
    _fields.push("approved_at")
    _fields.push("AXSalesId")
    _fields.push("AXInventTransId")
    _fields.push("AXPurchId")
    _fields.push("AXPurchInventTransId")
    _fields.push("AXId")
    _fields.push("fcCheckSFDApproved(t.id)")
    _fields.push("is_email_send")
    let result = await item_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///get 订单明细
  async getData(_params) {
    const line_biz_data = new biz_data_helper.base_entity_helper(
      "get_dispatch_orderforecast_line",
      {},
      {}
    )
    let _fields = _.map(fields.default, "key")
    _fields.push("id")
    _fields.push("order_forecast_id")
    let result = await line_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()
    // let _fields = _.map(fields.default, "key");
    // _fields.push("id");
    // _fields.push("order_forecast_id");
    // let result = await biz_data
    //   .selectAction({
    //     params: _params,
    //     fields: _fields
    //   })
    //   .run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///approve
  async approveData(_params) {
    let _actions = []
    const update_status_biz_data = new biz_data_helper.base_entity_helper(
      "update_approve_status",
      {},
      {}
    )
    let sd_update_biz_data = new biz_data_helper.base_entity_helper(
      "update_sPlant_OrderForecast_Dispatch",
      {},
      {}
    )
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_OrderForecast_Dispatch",
      {},
      {}
    )
    let so_approve_biz_data = new biz_data_helper.base_entity_helper(
      "sp_updateApproveStatus",
      {},
      {}
    )

    if (!_.isNull(_params.approve_data) && _params.approve_data) {
      _.each(_params.approve_data, t => {
        ///反审
        if (t.is_approved == false) {
          let credit_form = {
            itemId: t.order_dispatch_id,
            documentType: "SalesForcastDispatch",
            approveType: "",
            documentCreateByUsername: t.username,
            salesOrderAmountCNY: 0
          }
          _actions.push(
            so_approve_biz_data
              .execAction({
                params: credit_form,
                fields: ["id"]
              })
              .action({})
          )
        }
        _actions.push(
          update_status_biz_data
            .execAction({
              params: {
                IsApproved: t.is_approved == true ? 1 : 0,
                ApproveBy: t.username,
                status_id: t.id
              },
              fields: ["is_update_ok"]
            })
            .action({
              output_last_item_map: {
                is_update_ok: "is_update_ok"
              }
            })
        )
        if (!t.is_approved) {
          let _x = {
            SFDispatchId: t.order_dispatch_id,
            CreateBy: t.userId,
            // is_approved: t.is_approved
            IsEmailSend: 0
          }
          _actions.push(
            sd_update_biz_data
              .execAction({
                params: _x
              })
              .action({
                rollback_when: {
                  is_update_ok: {
                    "=": 1
                  }
                }
              })
          )
        }
      })
    }

    ///修改剩余派单数量
    // console.log(_params.update_valid_data);
    if (!_.isNull(_params.update_valid_data)) {
      let sf_biz_data = new biz_data_helper.base_entity_helper(
        "sPlant_OrderForecast_Line",
        {},
        {}
      )
      let update_soline_biz_data = new biz_data_helper.base_entity_helper(
        "update_sfl_validremain",
        {},
        {}
      )
      _actions.push(
        sf_biz_data
          .selectAction({
            params: {
              id: _params.update_valid_data.id
            },
            fields: ["is_cancel"]
          })
          .action({
            output_last_item_map: {
              is_cancel: "is_cancel"
            }
          })
      )
      _actions.push(
        update_soline_biz_data
          .execAction({
            params: {
              SForecastLineId: _params.update_valid_data.id
            },
            fields: ["valid_remain", "valid_approve"]
          })
          .action({
            rollback_when: {
              is_cancel: {
                "=": true
              }
            }
          })
      )
    }
    ///调用ax接口
    const h_biz_data = new biz_data_helper.base_entity_helper(
      "interface_invoke",
      {},
      {}
    )
    const x_biz_data = new biz_data_helper.base_entity_helper(
      "checkinterfaceresult",
      {},
      {}
    )
    _.each(_params.ax_params, t => {
      let _temp_dic_id = t.dic_id
      delete t.dic_id
      let _p = {
        company: t.company,
        method: "CMSalesForecast",
        jsonData: t.jsonData
      }
      _actions.push(
        h_biz_data
          .handlerAction({
            params: _p
          })
          .action({
            output_last_item_map: {
              status: "ax_interface_status",
              "data[0]": "AXParams"
            }
          })
      )
      _actions.push(
        x_biz_data
          .checkAction({
            params: {}
          })
          .action({
            rollback_when: {
              ax_interface_status: {
                "<>": 0
              }
            }
          })
      )
      _actions.push(
        item_biz_data
          .updateAction({
            params: {
              id: _temp_dic_id,
              AXId: ""
            }
          })
          .action({
            mixin_last_item_map: {
              AXId: "AXParams.AXId"
            }
          })
      )
    })

    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      ///判断是否已取消
      let res_data1 = _.filter(result.data.BatchResult.Actions, {
        Code: "data/e/update_sfl_validremain"
      })
      let is_not_cancel = true
      _.each(res_data1, t => {
        if (t.Result && t.Result.Rollback == true) {
          is_not_cancel = false
        }
      })
      if (!is_not_cancel) {
        return {
          type: "plant",
          state: false,
          data: [],
          message: "预测已取消，不能执行审核或反审！"
        }
      }
      ///检查是否AX错误
      let _rt = _.filter(result.data.BatchResult.Actions, {
        Code: "data/x/checkinterfaceresult"
      })
      let _rdata = _.filter(result.data.BatchResult.Actions, {
        Code: "data/h/interface_invoke"
      })
      let _is_ok = true
      _.each(_rt, t => {
        if (t.Result && t.Result.Rollback == true) {
          _is_ok = false
        }
      })
      if (_is_ok == true) {
        return {
          state: true,
          data: result.data.BatchResult.Actions,
          message: ""
        }
      } else {
        let _msg = ""
        _.each(_rdata, t => {
          if (
            !_.isNull(t.Result) &&
            t.Result.LastItem.ax_interface_status != 0
          ) {
            _msg = t.Result.Data[0][0].message
          }
        })
        ///记录ax调用失败日志
        let ep = {
          params: JSON.stringify(_actions),
          error_msg: _msg,
          result: JSON.stringify(_rdata)
        }
        common_controller.methods.createAXErorrLog("error_ax_interface_CMSalesForecast", ep)
        return {
          type: "ax",
          state: false,
          data: [],
          message: _msg
        }
      }
    } else {
      return null
    }
  },
  async approveListData(_params_list) {
    let _actions = []
    const update_status_biz_data = new biz_data_helper.base_entity_helper(
      "update_approve_status",
      {},
      {}
    )
    let sd_update_biz_data = new biz_data_helper.base_entity_helper(
      "update_sPlant_OrderForecast_Dispatch",
      {},
      {}
    )
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_OrderForecast_Dispatch",
      {},
      {}
    )
    let so_approve_biz_data = new biz_data_helper.base_entity_helper(
      "sp_updateApproveStatus",
      {},
      {}
    )
    _.each(_params_list, _params => {
      if (!_.isNull(_params.approve_data) && _params.approve_data) {
        _.each(_params.approve_data, t => {
          ///反审
          if (t.is_approved == false) {
            let credit_form = {
              itemId: t.order_dispatch_id,
              documentType: "SalesForcastDispatch",
              approveType: "",
              documentCreateByUsername: t.username,
              salesOrderAmountCNY: 0
            }
            _actions.push(
              so_approve_biz_data
                .execAction({
                  params: credit_form,
                  fields: ["id"]
                })
                .action({})
            )
          }
          _actions.push(
            update_status_biz_data
              .execAction({
                params: {
                  IsApproved: t.is_approved == true ? 1 : 0,
                  ApproveBy: t.username,
                  status_id: t.id
                },
                fields: ["is_update_ok"]
              })
              .action({
                output_last_item_map: {
                  is_update_ok: "is_update_ok"
                }
              })
          )
          if (!t.is_approved) {
            let _x = {
              SFDispatchId: t.order_dispatch_id,
              CreateBy: t.userId,
              // is_approved: t.is_approved
              IsEmailSend: 0
            }
            _actions.push(
              sd_update_biz_data
                .execAction({
                  params: _x
                })
                .action({
                  rollback_when: {
                    is_update_ok: {
                      "=": 1
                    }
                  }
                })
            )
          }
        })
      }

      ///修改剩余派单数量
      if (
        !_.isNull(_params.update_valid_data) &&
        _params.update_valid_data.length > 0
      ) {
        let sf_biz_data = new biz_data_helper.base_entity_helper(
          "sPlant_OrderForecast_Line",
          {},
          {}
        )
        let update_soline_biz_data = new biz_data_helper.base_entity_helper(
          "update_sfl_validremain",
          {},
          {}
        )
        _.each(_params.update_valid_data, t => {
          _actions.push(
            sf_biz_data
              .selectAction({
                params: {
                  id: t.id
                },
                fields: ["is_cancel"]
              })
              .action({
                output_last_item_map: {
                  is_cancel: "is_cancel"
                }
              })
          )
          _actions.push(
            update_soline_biz_data
              .execAction({
                params: {
                  SForecastLineId: t.id
                },
                fields: ["valid_remain", "valid_approve"]
              })
              .action({
                rollback_when: {
                  is_cancel: {
                    "=": true
                  }
                }
              })
          )
        })
      }
      ///调用ax接口
      const h_biz_data = new biz_data_helper.base_entity_helper(
        "interface_invoke",
        {},
        {}
      )
      const x_biz_data = new biz_data_helper.base_entity_helper(
        "checkinterfaceresult",
        {},
        {}
      )
      _.each(_params.ax_params, t => {
        let _p = {
          company: t.company,
          method: "CMSalesForecast",
          jsonData: t.jsonData
        }
        _actions.push(
          h_biz_data
            .handlerAction({
              params: _p
            })
            .action({
              output_last_item_map: {
                status: "ax_interface_status"
                // "data[0]": "AXParams"
              },
              output_result_data_code: "AXParams"
            })
        )
        _actions.push(
          x_biz_data
            .checkAction({
              params: {}
            })
            .action({
              rollback_when: {
                ax_interface_status: {
                  "<>": 0
                }
              }
            })
        )
        let dispatch_biz_data = new biz_data_helper.base_entity_helper(
          "update_sf_dispatch_ax_data",
          {},
          {}
        )
        _actions.push(
          dispatch_biz_data
            .execAction({
              params: {}
            })
            .action({
              mixin_result_data_map: {
                AXParams: "resultData[0][0].data"
              }
              // mixin_last_item_map: {
              //   AXId: "AXParams.AXId",
              //   id: "AXParams.CMForecastDispatchId"
              // }
            })
        )
      })
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      ///判断是否已取消
      let res_data1 = _.filter(result.data.BatchResult.Actions, {
        Code: "data/e/update_sfl_validremain"
      })
      let is_not_cancel = true
      _.each(res_data1, t => {
        if (t.Result && t.Result.Rollback == true) {
          is_not_cancel = false
        }
      })
      if (!is_not_cancel) {
        return {
          type: "plant",
          state: false,
          data: [],
          message: "预测已取消，不能执行审核或反审！"
        }
      }
      ///检查是否AX错误
      let _rt = _.filter(result.data.BatchResult.Actions, {
        Code: "data/x/checkinterfaceresult"
      })
      let _rdata = _.filter(result.data.BatchResult.Actions, {
        Code: "data/h/interface_invoke"
      })
      let _is_ok = true
      _.each(_rt, t => {
        if (t.Result && t.Result.Rollback == true) {
          _is_ok = false
        }
      })
      if (_is_ok == true) {
        return {
          state: true,
          data: result.data.BatchResult.Actions,
          message: ""
        }
      } else {
        let _msg = ""
        _.each(_rdata, t => {
          if (
            !_.isNull(t.Result) &&
            t.Result.LastItem.ax_interface_status != 0
          ) {
            _msg = t.Result.Data[0][0].message
          }
        })
        ///记录ax调用失败日志
        let ep = {
          params: JSON.stringify(_actions),
          error_msg: _msg,
          result: JSON.stringify(_rdata)
        }
        common_controller.methods.createAXErorrLog("error_ax_interface_CMSalesForecast", ep)
        return {
          type: "ax",
          state: false,
          data: [],
          message: _msg
        }
      }
    } else {
      return null
    }
  },
  ///del dispatch
  async deleteData(_params) {
    let _actions = []

    let del_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_OrderForecast_Dispatch",
      create,
      descriptor
    )

    ///后端剩余派单数量验证
    let if_can_modify_biz_data = new biz_data_helper.base_entity_helper(
      "CheckIfCanModifySalesForcastDispatch",
      {},
      {}
    )
    ///剩余派单数量
    let sf_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_OrderForecast_Line",
      {},
      {}
    )
    let update_soline_biz_data = new biz_data_helper.base_entity_helper(
      "update_sfl_validremain",
      {},
      {}
    )
    let cancel_email_biz_data = new biz_data_helper.base_entity_helper(
      "cancel_email_send",
      {},
      {}
    )
    ///删除派单
    _.each(_params.delete_data, t => {
      _actions.push(
        sf_biz_data
          .selectAction({
            params: {
              id: t.OrderForecast_Line_id
            },
            fields: ["is_cancel"]
          })
          .action({
            output_last_item_map: {
              is_cancel: "is_cancel"
            }
          })
      )
      ///剩余派单数检查
      _actions.push(
        if_can_modify_biz_data
          .execAction({
            params: {
              SalesForcastLineId: t.OrderForecast_Line_id,
              CurrentDispathId: t.id,
              action: "delete",
              inputQty: t.qty
            },
            fields: ["allowed"]
          })
          .action({
            output_last_item_map: {
              allowed: "allowed"
            },
            rollback_when: {
              is_cancel: {
                "=": true
              }
            }
          })
      )
      _actions.push(
        del_biz_data
          .deleteAction({
            params: {
              id: t.id
            }
          })
          .action({
            rollback_when: {
              allowed: {
                "=": false
              }
            }
          })
      )

      ///取消邮件
      _actions.push(
        cancel_email_biz_data
          .execAction({
            params: {
              type: "sfd",
              idx: _.toString(t.id)
            }
          })
          .action({})
      )
    })
    ///修改预测明细
    if (!_.isNull(_params.update_soline_form)) {
      _actions.push(
        update_soline_biz_data
          .execAction({
            params: {
              SForecastLineId: _params.update_soline_form.id
            },
            fields: ["valid_remain", "valid_approve"]
          })
          .action({})
      )
    }
    ///调用ax接口
    if (!_.isNull(_params.ax_params)) {
      const h_biz_data = new biz_data_helper.base_entity_helper(
        "interface_invoke",
        {},
        {}
      )
      const x_biz_data = new biz_data_helper.base_entity_helper(
        "checkinterfaceresult",
        {},
        {}
      )
      _.each(_params.ax_params, t => {
        let _p = {
          company: t.company,
          method: "CMSalesForecast",
          jsonData: t.jsonData
        }
        _actions.push(
          h_biz_data
            .handlerAction({
              params: _p
            })
            .action({
              output_last_item_map: {
                status: "ax_interface_status"
              }
            })
        )
        _actions.push(
          x_biz_data
            .checkAction({
              params: {}
            })
            .action({
              rollback_when: {
                ax_interface_status: {
                  "<>": 0
                }
              }
            })
        )
      })
    }

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      ///判断是否已取消
      let res_data1 = _.filter(result.data.BatchResult.Actions, {
        Code: "data/e/CheckIfCanModifySalesForcastDispatch"
      })
      let is_not_cancel = true
      _.each(res_data1, t => {
        if (t.Result && t.Result.Rollback == true) {
          is_not_cancel = false
        }
      })
      if (!is_not_cancel) {
        return {
          type: "plant",
          state: false,
          data: [],
          message: "预测已取消，不能执行删除！"
        }
      }
      ///检查是否超过剩余派单数量
      let is_ok = true
      let check_list1 = _.filter(result.data.BatchResult.Actions, {
        Code: "data/d/sPlant_OrderForecast_Dispatch"
      })
      _.each(check_list1, t => {
        if (t.Result && t.Result.Rollback == true) {
          is_ok = false
        }
      })
      if (!is_ok) {
        return {
          type: "plant",
          state: false,
          data: [],
          message: "不能删除已出库的派单！"
        }
      }
      ///检查ax调用情况
      let _rt = _.filter(result.data.BatchResult.Actions, {
        Code: "data/x/checkinterfaceresult"
      })
      let _rdata = _.filter(result.data.BatchResult.Actions, {
        Code: "data/h/interface_invoke"
      })
      let _is_ok = true
      _.each(_rt, t => {
        if (t.Result && t.Result.Rollback == true) {
          _is_ok = false
        }
      })
      if (_is_ok == true) {
        return {
          state: true,
          data: result.data.BatchResult.Actions,
          message: ""
        }
      } else {
        let _msg = ""
        _.each(_rdata, t => {
          if (
            !_.isNull(t.Result) &&
            t.Result.LastItem.ax_interface_status != 0
          ) {
            _msg = t.Result.Data[0][0].message
          }
        })
        return {
          type: "ax",
          state: false,
          data: [],
          message: _msg
        }
      }
    } else {
      return null
    }
  },
  ///修改
  async updateData(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_OrderForecast_Dispatch",
      create,
      descriptor
    )

    ///后端剩余派单数量验证
    let if_can_modify_biz_data = new biz_data_helper.base_entity_helper(
      "CheckIfCanModifySalesForcastDispatch",
      {},
      {}
    )
    ///修改剩余派单数量
    let update_soline_biz_data = new biz_data_helper.base_entity_helper(
      "update_sfl_validremain",
      {},
      {}
    )
    let so_approve_biz_data = new biz_data_helper.base_entity_helper(
      "sp_updateApproveStatus",
      {},
      {}
    )
    let sf_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_OrderForecast_Line",
      {},
      {}
    )
    let _actions = []
    ///修改派单
    for (var i in _params.update_data) {
      _actions.push(
        sf_biz_data
          .selectAction({
            params: {
              id: _params.update_data[i].OrderForecast_Line_id
            },
            fields: ["is_cancel"]
          })
          .action({
            output_last_item_map: {
              is_cancel: "is_cancel"
            }
          })
      )
      ///剩余派单数检查
      _actions.push(
        if_can_modify_biz_data
          .execAction({
            params: {
              SalesForcastLineId: _params.update_data[i].OrderForecast_Line_id,
              CurrentDispathId: _params.update_data[i].id,
              action: "update",
              inputQty: _params.update_data[i].qty
            },
            fields: ["allowed"]
          })
          .action({
            output_last_item_map: {
              allowed: "allowed"
            },
            rollback_when: {
              is_cancel: {
                "=": true
              }
            }
          })
      )
      _params.update_data[i].is_email_send = 0
      _actions.push(
        item_biz_data
          .updateAction({
            params: _params.update_data[i],
            fields: ["id"]
          })
          .action({
            rollback_when: {
              allowed: {
                "=": false
              }
            }
          })
      )
      ///审批
      let credit_form = {
        itemId: _params.update_data[i].id,
        documentType: "SalesForcastDispatch",
        approveType: "", //审批类型："" ---普通审批
        documentCreateByUsername:
          Vue.prototype.$global.global_data.local_username
      }
      _actions.push(
        so_approve_biz_data
          .execAction({
            params: credit_form,
            fields: ["id"]
          })
          .action({})
      )
    }
    ///修改预测明细
    if (
      _params.update_soline_form_list &&
      _params.update_soline_form_list.length > 0
    ) {
      _.each(_params.update_soline_form_list, t => {
        _actions.push(
          update_soline_biz_data
            .execAction({
              params: {
                SForecastLineId: t.id
              },
              fields: ["valid_remain", "valid_approve"]
            })
            .action({})
        )
      })
    }
    ///调用ax接口
    if (!_.isNull(_params.ax_params)) {
      const h_biz_data = new biz_data_helper.base_entity_helper(
        "interface_invoke",
        {},
        {}
      )
      const x_biz_data = new biz_data_helper.base_entity_helper(
        "checkinterfaceresult",
        {},
        {}
      )
      _.each(_params.ax_params, t => {
        let _p = {
          company: t.company,
          method: "CMSalesForecast",
          jsonData: t.jsonData
        }
        if (t.jsonData.length > 0) {
          _actions.push(
            h_biz_data
              .handlerAction({
                params: _p
              })
              .action({
                output_last_item_map: {
                  status: "ax_interface_status"
                }
              })
          )
          _actions.push(
            x_biz_data
              .checkAction({
                params: {}
              })
              .action({
                rollback_when: {
                  ax_interface_status: {
                    "<>": 0
                  }
                }
              })
          )
        }
      })
    }

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      ///判断是否已取消
      let res_data1 = _.filter(result.data.BatchResult.Actions, {
        Code: "data/e/CheckIfCanModifySalesForcastDispatch"
      })
      let is_not_cancel = true
      _.each(res_data1, t => {
        if (t.Result && t.Result.Rollback == true) {
          is_not_cancel = false
        }
      })
      if (!is_not_cancel) {
        return {
          type: "plant",
          state: false,
          data: [],
          message: "预测已取消，不能执行修改！"
        }
      }
      ///检查是否超过剩余派单数量
      let is_ok = true
      let check_list1 = _.filter(result.data.BatchResult.Actions, {
        Code: "data/u/sPlant_OrderForecast_Dispatch"
      })
      _.each(check_list1, t => {
        if (t.Result && t.Result.Rollback == true) {
          is_ok = false
        }
      })
      if (!is_ok) {
        return {
          type: "plant",
          state: false,
          data: null,
          message: "派单数量不能超过剩余派单数量和剩余送货数量！"
        }
      }
      ///检查ax调用情况
      let _rt = _.filter(result.data.BatchResult.Actions, {
        Code: "data/x/checkinterfaceresult"
      })
      let _rdata = _.filter(result.data.BatchResult.Actions, {
        Code: "data/h/interface_invoke"
      })
      let _is_ok = true
      _.each(_rt, t => {
        if (t.Result && t.Result.Rollback == true) {
          _is_ok = false
        }
      })
      if (_is_ok == true) {
        return {
          state: true,
          data: result.data.BatchResult.Actions,
          message: ""
        }
      } else {
        let _msg = ""
        _.each(_rdata, t => {
          if (
            !_.isNull(t.Result) &&
            t.Result.LastItem.ax_interface_status != 0
          ) {
            _msg = t.Result.Data[0][0].message
          }
        })
        return {
          type: "ax",
          state: false,
          data: [],
          message: _msg
        }
      }
    } else {
      return null
    }
  },
  ///取消
  async cancelData(_params, vm) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_OrderForecast_Dispatch",
      create,
      descriptor
    )

    ///后端剩余派单数量验证
    let if_can_modify_biz_data = new biz_data_helper.base_entity_helper(
      "CheckIfCanModifySalesForcastDispatch",
      {},
      {}
    )
    ///修改剩余派单数量
    let update_soline_biz_data = new biz_data_helper.base_entity_helper(
      "update_sfl_validremain",
      {},
      {}
    )

    let _actions = []
    ///修改派单
    for (var i in _params.update_data) {
      ///剩余派单数检查
      if (_params.update_data[i].is_cancel == 0) {
        _actions.push(
          if_can_modify_biz_data
            .execAction({
              params: {
                SalesForcastLineId:
                  _params.update_data[i].OrderForecast_Line_id,
                CurrentDispathId: _params.update_data[i].id,
                action: "create",
                inputQty: _params.update_data[i].qty
              },
              fields: ["allowed"]
            })
            .action({
              output_last_item_map: {
                allowed: "allowed"
              }
            })
        )
      }

      _params.update_data[i].is_email_send = 0
      _actions.push(
        item_biz_data
          .updateAction({
            params: _params.update_data[i],
            fields: ["id"]
          })
          .action({
            rollback_when: {
              allowed: {
                "=": false
              }
            }
          })
      )
    }
    ///修改预测明细
    if (
      _params.update_soline_form_list &&
      _params.update_soline_form_list.length > 0
    ) {
      _.each(_params.update_soline_form_list, t => {
        _actions.push(
          update_soline_biz_data
            .execAction({
              params: {
                SForecastLineId: t.id
              },
              fields: ["valid_remain", "valid_approve"]
            })
            .action({})
        )
      })
    }
    ///调用ax接口
    if (!_.isNull(_params.ax_params)) {
      const h_biz_data = new biz_data_helper.base_entity_helper(
        "interface_invoke",
        {},
        {}
      )
      const x_biz_data = new biz_data_helper.base_entity_helper(
        "checkinterfaceresult",
        {},
        {}
      )
      _.each(_params.ax_params, t => {
        let _p = {
          company: t.company,
          method: "CMSalesForecast",
          jsonData: t.jsonData
        }
        if (t.jsonData.length > 0) {
          _actions.push(
            h_biz_data
              .handlerAction({
                params: _p
              })
              .action({
                output_last_item_map: {
                  status: "ax_interface_status"
                }
              })
          )
          _actions.push(
            x_biz_data
              .checkAction({
                params: {}
              })
              .action({
                rollback_when: {
                  ax_interface_status: {
                    "<>": 0
                  }
                }
              })
          )
        }
      })
    }

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      ///检查是否超过剩余派单数量
      let is_ok = true
      let check_list1 = _.filter(result.data.BatchResult.Actions, {
        Code: "data/u/sPlant_OrderForecast_Dispatch"
      })
      _.each(check_list1, t => {
        if (t.Result && t.Result.Rollback == true) {
          is_ok = false
        }
      })
      if (!is_ok) {
        return {
          state: false,
          data: null,
          message:
            "保存失败！错误信息：派单数量不能超过剩余派单数量和剩余送货数量！"
        }
      }
      ///检查ax调用情况
      let _rt = _.filter(result.data.BatchResult.Actions, {
        Code: "data/x/checkinterfaceresult"
      })
      let _rdata = _.filter(result.data.BatchResult.Actions, {
        Code: "data/h/interface_invoke"
      })
      let _is_ok = true
      _.each(_rt, t => {
        if (t.Result && t.Result.Rollback == true) {
          _is_ok = false
        }
      })
      if (_is_ok == true) {
        return {
          state: true,
          data: result.data.BatchResult.Actions,
          message: ""
        }
      } else {
        let _msg = ""
        _.each(_rdata, t => {
          if (
            !_.isNull(t.Result) &&
            t.Result.LastItem.ax_interface_status != 0
          ) {
            _msg = vm.$t("notify.ax_error") + "：" + t.Result.Data[0][0].message
          }
        })
        return {
          state: false,
          data: [],
          message: _msg
        }
      }
    } else {
      return null
    }
  },
  ///检查订单是否审核
  async checkOrderIsApproved(_params) {
    let check_biz_data = new biz_data_helper.base_entity_helper(
      "CheckSFApproved",
      {},
      {}
    )
    let _actions = []
    ///检查订单是否审核
    _actions.push(
      check_biz_data
        .execAction({
          params: {
            itemId: _params.salesForecastId
          },
          fields: ["isApproved"]
        })
        .action({})
    )

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let _rt = _.filter(result.data.BatchResult.Actions, {
        Code: "data/e/CheckSFApproved"
      })
      let _is_ok = true
      _.each(_rt, t => {
        if (t.Result && t.Result.Data.length > 0) {
          _is_ok = t.Result.Data[0][0].isApproved
        }
      })
      return {
        state: _is_ok,
        data: [],
        message: "订单已经反审，不能执行该操作！"
      }
    } else {
      return null
    }
  }
}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
export { biz_data, dataForm, fields, methods, rules };

